export default __webpack_public_path__ + "static/media/member3.7e159e8a.png";